import React, {memo, useCallback} from 'react'
import {KTSVG} from '../../../../_metronic/helpers'
import {Card5} from '../../../../_metronic/partials/content/cards/Card5'
import {UseWindowSize} from '../../../modules/all-pages'
import {useReport} from '../context/ReportProvider'
import {Item, WPData} from '../../wp/types'
import {TablesWidget25} from '../../../../_metronic/partials/widgets/tables/web-formulaires/TablesWidget25'

interface PluginCount {
    title: string
    count: number
}

interface ItemProps {
    title: string
    count: number
    primary_color_50: string
    secondary_color: string
}

interface UpdateItemProps {
    name: string
    version_before: string
    version_after: string
    date: string
    primary_color: string
}

const CountItem = memo<ItemProps>(({
                                       title,
                                       count,
                                       secondary_color,
                                       primary_color_50,
                                   }) => (
    <Card5 title={title}
           stats={count >= 0 ? count : null}
           svgIcon={null}
           backgroundColor={primary_color_50}
           color={secondary_color}
    />
))

CountItem.displayName = 'CountItem'

const UpdateItem = memo<UpdateItemProps>(({
                                              name,
                                              version_before,
                                              version_after,
                                              date,
                                              primary_color,
                                          }) => (
    <div
        className="col-5 py-4 position-relative rounded-3 mb-10"
        style={{backgroundColor: primary_color}}
    >
        <span className="text-white">{name}</span>
        <div
            className="position-absolute p-2 min-w-125px rounded-3 bg-white"
            style={{right: 0, top: -20}}
        >
            <div className="d-flex flex-column align-items-center">
                <div className="mb-2">
          <span className="badge badge-light-danger fw-bold fs-8 text-start">
            {version_before}
          </span>
                    <KTSVG
                        path="/media/icons/duotune/arrows/arr064.svg"
                        className="svg-icon-4 svg-icon-primary mx-2"
                    />
                    <span className="badge badge-light-success fw-bold fs-8 text-end">
            {version_after}
          </span>
                </div>
                <span>{date}</span>
            </div>
        </div>
    </div>
))

UpdateItem.displayName = 'UpdateItem'

const BREAKPOINTS = {
    MOBILE: 480,
    TABLET: 768,
} as const

// Grid layout utilities
const getDeviceType = (width: number): 'mobile' | 'tablet' | 'desktop' => {
    if (width < BREAKPOINTS.MOBILE) return 'mobile'
    if (width < BREAKPOINTS.TABLET) return 'tablet'
    return 'desktop'
}

const getGridStyles = (deviceType: string) => {
    const baseStyles = {
        display: 'grid',
        gap: '10px',
    }

    const columnsByDevice = {
        mobile: '1fr',
        tablet: 'repeat(2, 1fr)',
        desktop: 'repeat(5, 1fr)',
    }

    return {
        ...baseStyles,
        gridTemplateColumns: columnsByDevice[deviceType as keyof typeof columnsByDevice],
    }
}

const styles = {
    grid: {
        display: "grid",
        gridTemplateColumns: "repeat(5, 1fr)",
        gridTemplateRows: "1fr",
        gridGap: 10
    },
    gridMd: {
        gridTemplateColumns: "repeat(2, 1fr)",
    },
    gridSm: {
        gridTemplateColumns: "repeat(2, 1fr)",
    }
};

const getItemStyles = (deviceType: string, index: number) => {
    if (deviceType === 'mobile' || (deviceType === 'tablet' && index === 0)) {
        return {gridColumn: '1 / -1'}
    }
    return {}
}


const Plugins = () => {

    const {innerWidth} = UseWindowSize()

    const {
        wpData: {
            plugin, theme, wp,
            total: {wordPressBody, modules, themes, total},
        },
    } = useReport()

    const allUpdates: Item[] = [...plugin, ...theme, ...wp]

    const pluginsCounts: PluginCount[] = [
        {title: 'Mises à jour', count: -1},
        {title: 'totales', count: modules + themes + wordPressBody},
        {title: 'modules ', count: modules},
        {title: 'thèmes ', count: themes},
        {title: 'corps wordpress ', count: wordPressBody},
    ]

    const deviceType = getDeviceType(innerWidth)
    const gridStyles = getGridStyles(deviceType)

    const updatedData = useCallback((data: Item[]): Item[] =>
            data.map(({type, name, slug, oldVersion, newVersion, created_at}) => ({
                type,
                name,
                slug,
                oldVersion,
                newVersion,
                created_at,
            }))
        , [])

    const getResponsiveStyles = () => {
        if (innerWidth <= 480) {
            return {...styles.grid, ...styles.gridSm}
        } else if (innerWidth <= 768) {
            return {...styles.grid, ...styles.gridMd}
        } else {
            return styles.grid
        }
    }

    return (
        <>
            <div className="w-full" style={getResponsiveStyles()}>
                {
                    pluginsCounts.map(({title, count}, index) =>
                        <div key={index}>
                            <CountItem key={index}
                                       title={title}
                                       count={count}
                                       secondary_color={"#e1006dbf"}
                                       primary_color_50={"#8bcefb"}
                            />
                        </div>)
                }
            </div>

            <div className="py-2 bg-white my-10">
                <div className="card">
                    <div className="card-body p-0">
                        <TablesWidget25 data={updatedData(allUpdates)} />
                    </div>
                </div>
            </div>
        </>
    )
}

export {Plugins}